import React, { Fragment, useContext, useEffect, useState } from "react";
import { MdSave } from "react-icons/md";
import { findAll } from "../../../../../services/Client__Service";
import { verifyDateMeeting } from "../../../../../services/config";
import { findOne, save } from "../../../../../services/Meeting__Service";
import notifyContext from "../../../../Context/notifyContext";
import Loader from "../../../../Loader/Loader";

const FormMeeting = ({
  meetingId = 0,
  view = false,
  modify = false,
  setShowAdd,
  setReload,
}) => {
  const notify = useContext(notifyContext);
  const [error, setError] = useState("");
  const [isSend, setIsSend] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [meeting, setMeeting] = useState({
    id: 0,
    objet: null,
    dateStart: null,
    timeStart: null,
    dateEnd: null,
    timeEnd: null,
    link: null,
    statut: null,
    clientId: 0,
  });

  const [clients, setClients] = useState([]);

  const [id, setId] = useState(meetingId);

  useEffect(() => {
    if (id !== undefined && id > 0) {
      fetchOneMeeting(id);
    } else {
      fetchAllClient();
    }
  }, [id]);

  const fetchOneMeeting = async (meetingId) => {
    findOne(meetingId)
      .then((response) => {
        setMeeting({ ...response.data, clientId: response.data.client.id });
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchAllClient = async () => {
    findAll()
      .then((response) => {
        setClients(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let display_errors = [];

    if (!meeting.objet) {
      display_errors.push({
        message: "Veuillez saisir l'objet",
        id_input: "objet",
      });
    }
    if (!meeting.dateStart) {
      display_errors.push({
        message: "Veuillez choisir la date de début",
        id_input: "dateStart",
      });
    }
    if (!meeting.timeStart) {
      display_errors.push({
        message: "Veuillez choisir l'heure de début",
        id_input: "timeStart",
      });
    }
    if (!meeting.dateEnd) {
      display_errors.push({
        message: "Veuillez choisir la date de fin",
        id_input: "dateStart",
      });
    }
    if (!meeting.timeEnd) {
      display_errors.push({
        message: "Veuillez choisir l'heure de fin",
        id_input: "timeStart",
      });
    }
    if (!meeting.dateStart) {
      display_errors.push({
        message: "Veuillez choisir la date de début",
        id_input: "dateStart",
      });
    }
    if (meeting.clientId === 0) {
      display_errors.push({
        message: "Veuillez sélectionner une client",
        id_input: "clientId",
      });
    }

    if (display_errors.length === 0) {
      display_errors = display_errors.concat(verifyDateMeeting(meeting));

      setError(
        display_errors.map((elt, key) => {
          return <p key={key}>{elt}</p>;
        })
      );
    } else {
      setError(
        display_errors.map(({ message, id_input }, key) => {
          return (
            <label key={key} htmlFor={id_input}>
              {message}
            </label>
          );
        })
      );
    }

    if (display_errors.length === 0) {
      setIsSend(true);
      save({ ...meeting })
        .then(() => {
          setIsSend(false);
          notify("Enregistré avec succès", "success");
          if (modify) {
            setReload(true);
          } else {
            setShowAdd(false);
          }
        })
        .catch((error) => {
          setIsSend(false);
          if (error.response.data.message !== undefined) {
            notify(error.response.data.message, "error");
          } else {
            notify("Problème au niveau du serveur", "error");
          }
        });
    }
  };

  const handleChange = (e) => {
    setMeeting((elt) => {
      return {
        ...elt,
        [e.target.name]: e.target.value,
      };
    });
  };
  useEffect(() => {
    if (error) {
      document.querySelector("form .error").scrollIntoView();
    }
  }, [error]);
  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        {!view && (
          <div className="form-header">
            <div className="error">{error}</div>
          </div>
        )}

        <div className="form-body">
          {meeting.id ? (
            <div className="form-group">
              <label htmlFor="objet" className="form-label">
                Client :
              </label>
              <input
                type="text"
                name="clientId"
                id="clientId"
                className="form-input"
                value={meeting.client.nom}
                onChange={handleChange}
                readOnly={view}
                wrap="true"
              />
            </div>
          ) : (
            <div className="form-group">
              <label htmlFor="clientId" className="form-label">
                Client :
              </label>

              <select
                name="clientId"
                id="clientId"
                className="form-select"
                value={meeting.clientId}
                onChange={handleChange}
                disabled={meeting.id !== 0 || view}
              >
                <option value="0" disabled>
                  Sélectionner un client
                </option>
                {clients.map((client) => {
                  const { id, nom } = client;
                  return (
                    <option key={id} value={id}>
                      {nom}
                    </option>
                  );
                })}
              </select>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="objet" className="form-label">
              Objet :
            </label>
            <input
              type="text"
              name="objet"
              id="objet"
              className="form-input"
              value={meeting.objet}
              onChange={handleChange}
              readOnly={view}
              wrap="true"
            />
          </div>
          <div className="form-group">
            <label htmlFor="dateStart" className="form-label">
              Date de début :
            </label>
            <input
              type="date"
              name="dateStart"
              id="dateStart"
              className="form-input"
              value={meeting.dateStart}
              onChange={handleChange}
              readOnly={view}
              wrap="true"
            />
          </div>
          <div className="form-group">
            <label htmlFor="timeStart" className="form-label">
              Heure de début :
            </label>
            <input
              type="time"
              name="timeStart"
              id="timeStart"
              className="form-input"
              value={meeting.timeStart}
              onChange={handleChange}
              readOnly={view}
              wrap="true"
            />
          </div>
          <div className="form-group">
            <label htmlFor="dateEnd" className="form-label">
              Date de Fin :
            </label>
            <input
              type="date"
              name="dateEnd"
              id="dateEnd"
              className="form-input"
              value={meeting.dateEnd}
              onChange={handleChange}
              readOnly={view}
              wrap="true"
            />
          </div>
          <div className="form-group">
            <label htmlFor="timeEnd" className="form-label">
              Heure de Fin :
            </label>
            <input
              type="time"
              name="timeEnd"
              id="timeEnd"
              className="form-input"
              value={meeting.timeEnd}
              onChange={handleChange}
              readOnly={view}
              wrap="true"
            />
          </div>
          <div className="form-group">
            <label htmlFor="link" className="form-label">
              Lien <small>(--optionnel--)</small> :
            </label>
            <input
              type="text"
              name="link"
              id="link"
              className="form-input"
              value={meeting.link}
              onChange={handleChange}
              readOnly={view}
              wrap="true"
            />
          </div>
        </div>

        {!view && (
          <div className="form-footer">
            <button type="submit" className="btn">
              <MdSave />
              Enregistrer
            </button>
            {/* <button type="reset" className="btn btn--outline">
              <MdCancel />
              Annuler
            </button> */}
          </div>
        )}
      </form>

      {isSend && <Loader loadingMsg="En cours d'envoi" />}
      {isLoading && <Loader loadingMsg="Chargement" />}
    </Fragment>
  );
};

export default FormMeeting;
